import {
  GET_TASKS,
  GET_TASKS_FAIL,
  GET_TASKS_SUCCESS,
  DELETE_KANBAN_SUCCESS,
  DELETE_KANBAN_FAIL,
  DELETE_KANBAN,
  ADD_CARD_DATA,
  ADD_CARD_DATA_SUCCESS,
  ADD_CARD_DATA_FAIL,
  UPDATE_CARD_DATA,
  UPDATE_CARD_DATA_SUCCESS,
  UPDATE_CARD_DATA_FAIL,
} from "./actionTypes"


export const getTasks = () => ({
  type: GET_TASKS,
})

export const getTasksSuccess = (tasks: any[]) => ({
  type: GET_TASKS_SUCCESS,
  payload: tasks,
})

export const getTasksFail = (error: any) => ({
  type: GET_TASKS_FAIL,
  payload: error,
})

export const deleteKanban = (kanban: any) => ({
  type: DELETE_KANBAN,
  payload: kanban,
})

export const deleteKanbanSuccess = (kanban: any) => ({
  type: DELETE_KANBAN_SUCCESS,
  payload: kanban,
})

export const deleteKanbanFail = (kanban: any) => ({
  type: DELETE_KANBAN_FAIL,
  payload: kanban,
})

export const addCardData = (data: any) => ({
  type: ADD_CARD_DATA,
  payload: data,
})

export const addCardDataSuccess = (cardData: any) => ({
  type: ADD_CARD_DATA_SUCCESS,
  payload: cardData,
})

export const addCardDataFail = (error: any) => ({
  type: ADD_CARD_DATA_FAIL,
  payload: error,
})

export const updateCardData = (card: any) => ({
  type: UPDATE_CARD_DATA,
  payload: card,
})

export const updateCardDataSuccess = (card: any) => ({
  type: UPDATE_CARD_DATA_SUCCESS,
  payload: card,
})

export const updateCardDataFail = (error: any) => ({
  type: UPDATE_CARD_DATA_FAIL,
  payload: error,
})
